import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import MyButton from '../../utils/MyButton';

// Redux
import { connect } from 'react-redux';
import { postScream, clearErrors } from '../../redux/actions/dataActions';

// MUI stuff
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Icons
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

const styles = {
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 8px 8px 24px'
    },
    submitButton: {
        display: 'block',
        marginTop: 16,
        marginLeft: 'auto',
        position: 'relative'
    },
    progressSpinner: {
        position: 'absolute'
    },
    textField: {
        marginBottom: 16
    }
};

class PostScream extends Component {

    state = {
        open: false,
        body: '',
        errors: {}
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState({ errors: nextProps.UI.errors });
        }
        if (!nextProps.UI.errors && !nextProps.UI.loading) {
            this.setState({ open: false, body: '', errors: {} })
        }
    }

    handleOpen = () => this.setState({ open: true });

    handleClose = () => {
        this.props.clearErrors();
        this.setState({ open: false, body: '', errors: {} });
    }

    handleChange = event => this.setState({ [event.target.name]: event.target.value });

    handleSubmit = event => {
        event.preventDefault();
        this.props.postScream({ body: this.state.body });
    };

    render() {
        const { errors } = this.state;
        const { classes, UI: { loading } } = this.props;

        return (
            <>
                <MyButton tip="Post a Scream!" onClick={this.handleOpen}>
                    <AddIcon />
                </MyButton>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    fullWidth
                    maxWidth="sm">
                    <DialogTitle disableTypography className={classes.dialogTitle}>
                        <Typography variant="h6">Post a new Scream</Typography>
                        <IconButton onClick={this.handleClose} size="small" aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <form onSubmit={this.handleSubmit}>
                            <Stack spacing={2.5} sx={{ mt: 1 }}>
                                <TextField
                                    name="body"
                                    type="text"
                                    label="Scream!"
                                    multiline
                                    fullWidth
                                    rows={4}
                                    placeholder="What's on your mind, ape?"
                                    error={errors.body ? true : false}
                                    helperText={errors.body}
                                    onChange={this.handleChange}
                                    value={this.state.body}
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={loading}
                                    sx={{ alignSelf: 'flex-end', position: 'relative', minWidth: 100 }}>
                                    POST
                                    {loading && <CircularProgress size={22} className={classes.progressSpinner} />}
                                </Button>
                            </Stack>
                        </form>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}

PostScream.propTypes = {
    postScream: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ UI: state.UI });

export default connect(mapStateToProps, { postScream, clearErrors })(withStyles(styles)(PostScream));
